/**
 *
 * ResultByDimension
 *
 */

import React from "react"
import { Spin, Pagination, Popover } from "antd"
import { Link } from "react-router-dom"

// import PropTypes from 'prop-types';
import questionIcon from "images/question.svg"
import ProgressBar from "../ProgressBar"
import "./index.less"
import { CaretUpOutlined, CaretDownOutlined } from "@ant-design/icons"
import MeasurementColorRange from "../MeasurementColorRange"

/* eslint-disable react/prefer-stateless-function */
class ResultByDimension extends React.Component {
  state = {
    paginationCurrentPage: 1,
    paginationPageSize: 10,
    rows: [],
    columns: [
      {
        name: "Líder",
        order: {
          active: false,
          type: "asc",
          key: "name",
        },
      },
      { name: "Respuestas" },
      { name: "División" },
      { name: "Tasa de respuesta" },
      {
        name: "Resultado",
        order: {
          active: false,
          type: "asc",
          key: "value_visible",
        },
      },
      {
        name: "Variación",
        order: {
          active: false,
          type: "asc",
          key: "value_visible",
        },
      },
      { name: "Acciones" },
    ],
    order: {
      key: "-",
      type: "asc",
    },
    sorter: false,
  }

  componentDidMount() {
    this.setState({
      paginationCurrentPage: 1,
      rows: this.props.data.slice(0, this.state.paginationPageSize),
    })
  }

  UNSAFE_componentWillReceiveProps(next) {
    this.setState({
      paginationCurrentPage: 1,
      rows: next.data.slice(0, this.state.paginationPageSize),
    })
  }

  renderRow = (item, index) => {
    const { showVariation } = this.props

    return (
      <div
        key={index}
        className="ResultByDivisionComponent-table-body-row"
        style={{
          gridTemplateColumns: showVariation
            ? "1.5fr 0.5fr 1.5fr 1.5fr 0.6fr minmax(108px, 0.6fr) 1.24fr"
            : "1.5fr 0.5fr 1.5fr 1.5fr 0.6fr 1.24fr",
        }}>
        <div className="ResultByDivisionComponent-table-body-row-description">
          {item.name}
        </div>
        <div className="ResultByDivisionComponent-table-body-row-description">
          {item.employees}
        </div>
        <div className="ResultByDivisionComponent-table-body-row-description">
          {item.division_name}
        </div>
        <div className="ResultByDivisionComponent-table-body-row-description">
          {item.anonymity_check.valid ? (
            <ProgressBar
              style={{ width: "80%" }}
              custom={{
                color: item.response_rate.rate_color,
                value: item.response_rate.rate,
                value_visible: item.response_rate.rate_visible,
              }}
            />
          ) : (
            <Popover
              content={
                <div style={{ maxWidth: 220, textAlign: "center" }}>
                  El total de respuestas debe ser mayor o igual a{" "}
                  {item.anonymity_check.current_used} para poder mostrar los
                  resultados del líder.
                </div>
              }>
              <div style={{ width: "fit-content" }}>-</div>
            </Popover>
          )}
        </div>
        <div className="ResultByDivisionComponent-table-body-row-description">
          {item.anonymity_check.valid ? (
            <span style={{ backgroundColor: item.color, width: 60 }}>
              {item.value_visible}
            </span>
          ) : (
            <Popover
              content={
                <div style={{ maxWidth: 220, textAlign: "center" }}>
                  El total de respuestas debe ser mayor o igual a{" "}
                  {item.anonymity_check.current_used} para poder mostrar los
                  resultados del líder.
                </div>
              }>
              <div style={{ width: "fit-content" }}>-</div>
            </Popover>
          )}
        </div>

        {showVariation && (
          <div className="ResultByDivisionComponent-table-body-row-description">
            {item.variation == 0
              ? item.variation === 0
                ? "0%"
                : "-"
              : item.variation > 0
              ? `${item.variation}%`
              : `${item.variation}%`.replace(/-(?=\d)/, "")}
            {item.variation != 0 && (
              <div
                className={`content-variation__triangle ${
                  item.variation > 0
                    ? "content-variation__triangle--positive"
                    : ""
                }`}
              />
            )}
          </div>
        )}

        <div
          className={`ResultByDivisionComponent-table-body-row-description link ${
            !item.anonymity_check.valid ? "link-disable" : ""
          }`}>
          {item.anonymity_check.valid ? (
            <Link
              to={`/reports/measure/${this.props.match.params.id}/teams/${item.id}/dimensions`}>
              Ver análisis detallado &gt;
            </Link>
          ) : (
            <Popover
              content={
                <div style={{ maxWidth: 220, textAlign: "center" }}>
                  El total de respuestas debe ser mayor o igual a{" "}
                  {item.anonymity_check.current_used} para poder mostrar los
                  resultados del líder.
                </div>
              }>
              <div style={{ width: "fit-content" }}>
                Ver análisis detallado &gt;
              </div>
            </Popover>
          )}
        </div>
      </div>
    )
  }

  onShowSizeChange = (current, pageSize) => {
    this.setState({ paginationPageSize: pageSize }, () => {
      this.onChange(1)
    })
  }

  onChange = (page) => {
    const { data } = this.props
    const { paginationPageSize } = this.state
    this.setState({ paginationCurrentPage: page }, () => {
      const startIndex = (page - 1) * paginationPageSize
      const endIndex = Math.min(
        startIndex + paginationPageSize - 1,
        data.length - 1
      )
      const rows = data.slice(startIndex, endIndex + 1)
      this.setState({ rows })
    })
  }

  /* eslint-disable */
  compareValues = (key, order = "asc") => {
    key = key === "value_visible" ? "value" : key
    return function(a, b) {
      if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
        return 0
      }

      let varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key]
      let varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key]
      if (
        Number.isInteger(parseInt(varA)) &&
        Number.isInteger(parseInt(varB))
      ) {
        varA = parseInt(varA)
        varB = parseInt(varB)
      }
      let comparison = 0
      if (varA > varB) {
        comparison = 1
      } else if (varA < varB) {
        comparison = -1
      }
      return order == "desc" ? comparison * -1 : comparison
    }
  }
  /* eslint-enable */

  sortColumn = (key, type) => {
    const { columns } = this.state
    columns.map((e) => {
      if (e.order) e.order.active = false
    })
    columns[key].order.type = type
    columns[key].order.active = true
    let items = this.props.data
    items = items.sort(this.compareValues(columns[key].order.key, type))
    this.setState(
      {
        columns,
        sorter: columns[key].order.type,
      },
      this.onChange(1)
    )
  }

  renderIconQuestions = () => {
    const { measureColorRange } = this.props
    return <MeasurementColorRange measureColorRange={measureColorRange} />
  }

  setTitleColumn = (item) => {
    let response = item.name
    if (item.name === "Acciones") {
      response = (
        <div>
          <div style={{ float: "left" }}>{item.name}</div>
          <div style={{ float: "right" }}>{this.renderIconQuestions()}</div>
        </div>
      )
    }

    return response
  }

  render() {
    const { data, isLoading, showVariation } = this.props
    const { paginationCurrentPage, rows, columns, sorter } = this.state

    const contentVariation = (
      <div className="content-variation">
        <p>
          La <span>variación</span> hace referencia a la diferencia porcentual
          entre el resultado del indicador en la medición anterior versus la
          medición actual.
        </p>
        <div>
          <div className="content-variation__triangle content-variation__triangle--positive" />
          Variación positiva (incremento)
        </div>
        <div>
          <div className="content-variation__triangle" />
          Variación negativa (disminución)
        </div>
      </div>
    )

    return (
      <div className="ResultByDivisionComponent">
        <div className="ResultByDivisionComponent-table">
          <div className="ResultByDivisionComponent-table-body ResultByDivisionComponent-table-body-header">
            <div
              className="ResultByDivisionComponent-table-body-row"
              style={{
                // gridTemplateColumns: '1.5fr 0.5fr 1.5fr 1.5fr 0.6fr 1.24fr'
                gridTemplateColumns: showVariation
                  ? "1.5fr 0.5fr 1.5fr 1.5fr 0.6fr minmax(108px, 0.6fr) 1.24fr"
                  : "1.5fr 0.5fr 1.5fr 1.5fr 0.6fr 1.24fr",
              }}>
              {columns.map((item, index) => {
                if (!showVariation && item.name === "Variación") return

                return (
                  <div
                    key={index}
                    className="ResultByDivisionComponent-table-body-row-title">
                    {this.setTitleColumn(item)}

                    {item.name === "Variación" && (
                      <Popover
                        placement="bottomRight"
                        content={contentVariation}>
                        <img
                          src={questionIcon}
                          alt="question"
                          style={{ marginLeft: 4, cursor: "pointer" }}
                        />
                      </Popover>
                    )}

                    {!!item.order && (
                      <div
                        className="reorderColumn"
                        onClick={() =>
                          this.sortColumn(
                            index,
                            sorter == "asc" ? "desc" : "asc"
                          )
                        }>
                        <CaretUpOutlined
                          className={`reorderColumn-up ${
                            item.order.active && item.order.type === "asc"
                              ? "reorderColumn-active"
                              : ""
                          }`}
                        />
                        <CaretDownOutlined
                          type="caret-down"
                          className={`reorderColumn-down ${
                            item.order.active && item.order.type === "desc"
                              ? "reorderColumn-active"
                              : ""
                          }`}
                        />
                      </div>
                    )}
                  </div>
                )
              })}
            </div>
          </div>

          {isLoading ? (
            <div className="ResultByDivisionComponent-table-body-loading">
              <Spin size="large" />
            </div>
          ) : (
            rows && (
              <div className="ResultByDivisionComponent-table-body">
                {rows.map((item, index) => this.renderRow(item, index))}
              </div>
            )
          )}
          {!isLoading && (
            <Pagination
              showSizeChanger
              onShowSizeChange={this.onShowSizeChange}
              onChange={this.onChange}
              defaultCurrent={paginationCurrentPage}
              total={data.length}
            />
          )}
        </div>
      </div>
    )
  }
}

ResultByDimension.propTypes = {}

export default ResultByDimension
